import React, { useState } from 'react';
import { Button, CopyLink, EmailInput, useForm, useWindowSize } from 'library';
import { browserTrackCTAClick } from 'utils/segment';

import { trackSharedEmail } from '../utils/ppqTrackRequest';

const PPQPositiveOutcome = ({ inviteLink, partnerName }) => {
  const { isScreenSize } = useWindowSize();
  const { handleSubmit, registerField } = useForm();
  const [formSubmit, setFormSubmit] = useState(false);
  const trackShareViaEmail = (email) => {
    browserTrackCTAClick({
      destination: inviteLink,
      location: 'body',
      style: 'primary',
      text: 'Share via Email',
      type: 'button',
      email: email,
      partner_name: partnerName,
    });
  };

  const trackCopyLink = () => {
    browserTrackCTAClick({
      style: 'primary',
      text: 'Copy Invite Link',
      type: 'copy button',
      destination: inviteLink,
    });
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      return trackCopyLink();
    }
  };

  const handleFormOnSubmit = (data) => {
    trackShareViaEmail(data.email);
    trackSharedEmail(data.email, partnerName).finally(() => {
      setFormSubmit(true);
    });
  };

  return (
    <div>
      <h1>Good news!</h1>
      <p>
        According to the information you shared, your homeowner may be eligible for a Hometap investment provided that
        they meet our full underwriting criteria.
        <br />
        <br />
        <strong>Next Steps:</strong>
        <br />
        <br />
        1. Educate your homeowner about Hometap to see if they are interested in obtaining an investment from us. Use
        the resources below to help guide the conversation.
        <br />
        <br />
        2. Share the custom-branded link to our homepage below with your homeowner and encourage them to get started.
        <span className="PPQOutcomeNote">
          NOTE: Sending your client to Hometap's website directly, rather than using the below link, will result in a
          lead not being properly attributed to your company (and potential loss of commission payments).
        </span>
      </p>
      {formSubmit === false ? (
        <form className="PPQEmailShare" onSubmit={handleSubmit(handleFormOnSubmit)}>
          <EmailInput required label="" placeholder="Enter email address" {...registerField('email')} />
          <Button type="submit" size={isScreenSize('sm') ? 'small' : 'normal'}>
            Share via email
          </Button>
        </form>
      ) : (
        <h2>Invite Sent!</h2>
      )}
      <h4>Or share your invite link:</h4>
      <div onClick={trackCopyLink} role="button" tabIndex="-1" onKeyDown={handleKeyDown}>
        <CopyLink text={inviteLink || 'https://hometap.com/homeowner-check/'} />
      </div>
    </div>
  );
};

export default PPQPositiveOutcome;
